import React from 'react';
import PropTypes from 'prop-types';
import { DropdownToggle, UncontrolledDropdown, DropdownMenu } from 'reactstrap';
import Icon from '../common/containers/icon';
import MenuDropdownItem from './menuDropdownItem';
import SidebarDirectFormNavItem from './sidebarDirectFormNavItem';
const TabGroupSidebarMenu = ({
  label,
  icon,
  className: _className = '',
  items,
  expanded,
  drawerOpen,
  mobileNavHidden: _mobileNavHidden = false,
  onCloseDrawer,
  pathname
}) => {
  const showLabels = expanded || drawerOpen;
  const isActive = items.some(item => {
    if (item.type === 'directForm' && item.directFormType) {
      return pathname.startsWith(`/directForms/new/${item.directFormType}`);
    }
    if (!item.href) return false;
    const path = item.href.replace('/#', '');
    return pathname.startsWith(path);
  });
  return /*#__PURE__*/React.createElement("li", {
    className: `global-nav-sidebar__item ${_className}`
  }, /*#__PURE__*/React.createElement(UncontrolledDropdown, {
    direction: "right"
  }, /*#__PURE__*/React.createElement(DropdownToggle, {
    tag: "button",
    type: "button",
    className: `global-nav-sidebar__link global-nav-sidebar__link--dropdown${isActive ? ' global-nav-sidebar__link--active' : ''}`,
    "aria-label": !showLabels ? label : undefined,
    title: !showLabels ? label : undefined,
    tabIndex: _mobileNavHidden ? -1 : undefined,
    disabled: _mobileNavHidden || undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "global-nav-sidebar__icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: icon
  })), /*#__PURE__*/React.createElement("span", {
    className: "global-nav-sidebar__label"
  }, label)), /*#__PURE__*/React.createElement(DropdownMenu, {
    positionFixed: true,
    className: "global-nav-sidebar__dropdown-menu",
    modifiers: {
      preventOverflow: {
        enabled: true,
        boundariesElement: 'viewport',
        padding: 8
      }
    }
  }, items.map(item => {
    if (item.type === 'directForm') {
      return /*#__PURE__*/React.createElement(SidebarDirectFormNavItem, {
        key: item.key,
        variant: "dropdown",
        identifier: item.identifier,
        title: item.label,
        icon: item.icon,
        directFormType: item.directFormType,
        className: item.className,
        onCloseDrawer: onCloseDrawer
      });
    }
    return /*#__PURE__*/React.createElement(MenuDropdownItem, {
      key: item.key,
      className: item.className,
      title: item.label,
      glyph: item.icon,
      href: item.href,
      onClick: onCloseDrawer
    });
  }))));
};
TabGroupSidebarMenu.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    className: PropTypes.string,
    href: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string.isRequired,
    identifier: PropTypes.string,
    directFormType: PropTypes.string
  })).isRequired,
  expanded: PropTypes.bool.isRequired,
  drawerOpen: PropTypes.bool.isRequired,
  mobileNavHidden: PropTypes.bool,
  onCloseDrawer: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired
};
export default TabGroupSidebarMenu;